var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h-[270px] xl:h-[285px] 2xl:h-[396px] 3xl:h-[500px] mb-9"},[_c('image-wrapper',{attrs:{"products":_vm.product_shows,"nav_selected":_vm.nav_selected}})],1),_vm._v(" "),(_vm.nav_selected >= 0)?_c('navigation',{attrs:{"navigations":_vm.navigations},on:{"clickedNav":_vm.navAct}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }